// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullscreen-loading {
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  height: calc(100vh - 64px);
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #069dae;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 0.9s linear infinite;
}

@media only screen and (max-width: 430px) {
  .button-setup {
    margin-top: 10px;
    margin-left: -10px;
  }
}

@media only screen and (max-width: 486px) {
  .button-setup {
    margin-top: 10px;
    margin-left: -10px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/setup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".fullscreen-loading {\n  position: fixed;\n  top: 64px;\n  left: 0;\n  width: 100%;\n  height: calc(100vh - 64px);\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner {\n  border: 6px solid #f3f3f3;\n  border-top: 6px solid #069dae;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 0.9s linear infinite;\n}\n\n@media only screen and (max-width: 430px) {\n  .button-setup {\n    margin-top: 10px;\n    margin-left: -10px;\n  }\n}\n\n@media only screen and (max-width: 486px) {\n  .button-setup {\n    margin-top: 10px;\n    margin-left: -10px;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
